import BlazePose from "@/elite-lib-yt/pose-detectors/blazepose/BlazePose";

export default class EliteRep extends BlazePose {

    constructor(eliteService, options) {
        super(eliteService, options);
        this.visible = false;
        this.form = 0;
        this.direction = 0;
        this.count = 0;
        this.directionTotal = 0;
        this.total = 0;
        this.start = true;
        this.baseLine = options.baseLine;
        this.poseLandmarksCallback = options?.poseLandmarksCallback;
        this.onResult = options?.onResult;
        this.onVisibilityChange = options?.onVisibilityChange;
        this.totalRepDeviation = options?.totalRepDeviation ? options?.totalRepDeviation : 30;
    }

    initCamera(videoEl, canvasEl, instructorVideoEl, videoId, onlyBlazePose = false) {
        this.onlyBlazePose = onlyBlazePose;
        if (onlyBlazePose) {
            return this.initBlazePoseOnly(videoEl, canvasEl, instructorVideoEl, videoId, this.onPoseLandmarks);
        }
        return this.initBlazePose(videoEl, canvasEl, instructorVideoEl, videoId, this.onPoseLandmarks);
    }

    onPoseLandmarks(landmarks) {
        if (typeof this.poseLandmarksCallback === 'function') {
            this.poseLandmarksCallback(landmarks);
        }
        this.countRepetition(landmarks);
    }

    countRepetition(landmarks) {
        if (typeof this.onVisibilityChange === 'function') {
            if (this.visible !== (landmarks && landmarks.length === 33)) {
                this.onVisibilityChange((landmarks && landmarks.length === 33));
            }
        }
        this.visible = (landmarks && landmarks.length === 33);
        if (this.visible) {
            if (this.checkForm(landmarks, this.baseLine.form)) {
                this.form = 1;
            }
            if (this.form === 1 && this.start) {
                // this.checkMotion(landmarks, this.baseLine.motion);
                this.checkMotionCount(landmarks, this.baseLine.motion);
                this.checkMotionTotal(landmarks, this.baseLine.motion);
            }
        }
    }

    uploadCount() {
        this.eliteService.updateRepCount(this.videoId, this.sessionId, this.count).then(resp => { });
    }

    checkMotionCount(landmarks, motion) {
        const total = motion.length;
        const pmc = 1 / total;
        let i = 0;
        // Loop through motion array
        for (const form of motion) {
            // If current direction matches the motion array index i.e form which we need to check in current direction
            if (this.direction === i) {
                // Check if the from is correct if its correct then update the count
                if (this.checkForm(landmarks, form)) {
                    this.count += pmc;
                    // update the direction to the next form if its a last form in the array then to the first form
                    if (i === (motion.length - 1)) {
                        this.direction = 0;
                    }
                    else {
                        this.direction = i + 1;
                    }
                    if (typeof this.onResult === 'function') {
                        this.onResult(this.count, this.total);
                        //Only upload count for full motion rep
                        if (!(this.count % 1) && !this.onlyBlazePose) {
                            this.uploadCount();
                        }
                    }
                }
            }
            i += 1;
        }
    }

    checkMotionTotal(landmarks, motion) {
        const total = motion.length;
        const pmc = 1 / total;
        let i = 0;
        // Loop through motion array
        for (const form of motion) {
            // If current direction matches the motion array index i.e form which we need to check in current direction
            if (this.directionTotal === i) {
                // Check if the from is correct if its correct then update the count
                if (this.checkForm(landmarks, form, this.totalRepDeviation)) {
                    this.total += pmc;
                    // update the direction to the next form if its a last form in the array then to the first form
                    if (i === (motion.length - 1)) {
                        this.directionTotal = 0;
                    }
                    else {
                        this.directionTotal = i + 1;
                    }
                    if (typeof this.onResult === 'function') {
                        this.onResult(this.count, this.total);
                        //Only upload count for full motion rep
                        if (!(this.total % 1) && !this.onlyBlazePose) {
                            this.uploadCount();
                        }
                    }
                }
            }
            i += 1;
        }
    }

    checkMotion(landmarks, motion) {
        const total = motion.length;
        const pmc = 1 / total;
        let i = 0;
        // Loop through motion array
        for (const form of motion) {
            // If current direction matches the motion array index i.e form which we need to check in current direction
            if (this.direction === i) {
                // Check if the from is correct if its correct then update the count
                const formResult = this.checkFormQuality(landmarks, form);
                if (formResult !== 0) {
                    if (formResult === 1) {
                        this.count += pmc;
                        this.total += pmc;
                    }
                    if (formResult === 2) {
                        this.total += pmc;
                    }
                    // update the direction to the next form if its a last form in the array then to the first form
                    if (i === (motion.length - 1)) {
                        this.direction = 0;
                    }
                    else {
                        this.direction = i + 1;
                    }
                    if (typeof this.onResult === 'function') {
                        this.onResult(this.count, this.direction, this.total);
                        //Only upload count for full motion rep
                        if (!(this.count % 1) && !this.onlyBlazePose) {
                            this.uploadCount();
                        }
                    }
                }
            }
            i += 1;
        }
    }

    checkForm(landmarks, form, deviation = null) {
        for (const pose of form) {
            const angle = this.getAngle(landmarks, pose.p1, pose.p2, pose.p3);
            let nd;
            let pd;
            if (deviation) {
                nd = deviation;
                pd = deviation;
            }
            else {
                nd = pose.nd;
                pd = pose.pd;
            }
            if (!this.checkAngle(angle, pose.a, nd, pd)) {
                return false;
            }
        }
        return true;
    }

    checkFormQuality(landmarks, form, deviation = 40) {
        let accurate = true;
        let total = true;
        for (const pose of form) {
            const angle = this.getAngle(landmarks, pose.p1, pose.p2, pose.p3);
            // Accurate angle check
            const acc = !this.checkAngle(angle, pose.a, pose.nd, pose.pd);
            // console[acc ? "error" : "info"](`Checking accurate: angle:${angle} exp angle: ${pose.a} | pd: ${pose.pd} | nd: ${pose.nd} | matches: ${!acc}`);
            if (acc) {
                accurate = false;
            }
            const tot = !this.checkAngle(angle, pose.a, deviation, deviation);
            // console[tot ? "error" : "info"](`Checking total: angle:${angle} exp angle: ${pose.a} | pd: ${deviation} | nd: ${deviation} | matches: ${!tot}`)
            // Total angle check
            if (tot) {
                total = false
            }
        }
        if (accurate) {
            return 1;
        }
        if (total) {
            return 2;
        }
        return 0;
    }

    // If expecting 90 with deviation of +-10 so angle of 80 to 100 should send true
    checkAngle(angle, expectedAngle, negativeDeviation = 10, positiveDeviation = 10) {
        let a1 = expectedAngle - negativeDeviation;
        let a2 = expectedAngle + positiveDeviation;
        return angle > a1 && angle < a2;
    }

    getAngle(landmarks, p1, p2, p3) {
        try {
            const {x: x1, y: y1} = landmarks[p1];
            const {x: x2, y: y2} = landmarks[p2];
            const {x: x3, y: y3} = landmarks[p3];
            let angle = this.degrees(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y1 - y2, x1 - x2));
            if (angle < 0) {
                angle += 360;
                if (angle > 180) {
                    angle = 360 - angle;
                }
            } else if (angle > 180) {
                angle = 360 - angle;
            }
            return angle;
        } catch (e) {
            console.log(e.message);
        }
        return 0;
    }

    degrees(radians) {
        return radians * (180 / Math.PI);
    }

    dispose() {
        this.videoElement.srcObject.getTracks().forEach(function(track) {
            //stop camera
            track.stop();
        });
    }

}
